import React, { useState, useCallback, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Loading from "../../../common/Loading";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";

import Button from "components/CustomButtons/Button";

import { actionCreators as actionCreatorsAdmin } from "../../../../_actions/adminActions";
import { currentYear, yearList } from "../../../../utils";

const useStyles = makeStyles(theme => ({
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  dialogActions: {
    justifyContent: "center"
  },
  formControl: {
    width: "50%"
  },
  menuPaper: {
    maxHeight: 200
  },
  gridContainer: {
    minHeight: 150
  }
}));

const FiscalYearDialog = ({
  open,
  onClose,
  year,
  getFiscalYear,
  updateFiscalYear,
  isFetching,
  isFetched,
  isUpdating
}) => {
  const classes = useStyles();
  const [fiscalYear, setFiscalYear] = useState(currentYear);
  const [isDirty, setDirty] = useState(false);

  useEffect(() => {
    if (!isFetching.FISCAL_YEAR && !isFetched.FISCAL_YEAR) {
      getFiscalYear();
    }
  }, []);

  useEffect(() => {
    if (year) {
      setFiscalYear(year);
    }
  }, [year]);

  useEffect(() => {
    if (isUpdating.FISCAL_YEAR) {
      onClose();
    }
  }, [isUpdating]);

  useEffect(() => {
    if (open) {
      setDirty(false);
    }
  }, [open]);

  const handleFiscalYear = useCallback(({ target: { value } }) => {
    setFiscalYear(value);
  }, []);

  const handleSave = useCallback(() => {
    setDirty(true);
    updateFiscalYear(fiscalYear);
  }, [updateFiscalYear, fiscalYear]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Fiscal Year</DialogTitle>
      <DialogContent>
        <Typography variant="body1" className={classes.marginBottom}>
          Change the current fiscal year using the dropdown below
        </Typography>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.gridContainer}
          spacing={2}
        >
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel id="demo-simple-select-outlined-label">
              Fiscal Year
            </InputLabel>
            <Select
              labelId="demo-simple-select-outlined-label"
              value={fiscalYear}
              onChange={handleFiscalYear}
              label="Fiscal Year"
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >
              {yearList.map(value => (
                <MenuItem value={value} key={`fiy-${value}`}>
                  FY{value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActions }}>
        {isDirty ? (
          <Loading />
        ) : (
          <>
            <Button color="success" variant="contained" onClick={handleSave}>
              OK
            </Button>
            <Button color="danger" variant="contained" onClick={onClose}>
              Cancel
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = state => ({
  year: state.adminReducer.fiscalYear,
  isFetching: state.adminReducer.isFetching,
  isFetched: state.adminReducer.isFetched,
  isUpdating: state.adminReducer.isUpdating
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsAdmin }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FiscalYearDialog);
